import { useTheme } from "@mui/material";
import type { Props } from "react-apexcharts";

type ChartElement = {
	label: string;
	value: number;
	color: string;
};

export const useDistributionChartOptions = (
	data: ChartElement[],
	//country?: string,
	//currency?: string,
) => {
	const theme = useTheme();

	const chartSeries = data.map((item: ChartElement) => item.value);
	const labels = data.map((item: ChartElement) => item.label);
	const colors = data.map(
		(item: ChartElement) => item.color || theme.palette.primary.main,
	);

	const options: Props = {
		chart: {
			type: "donut",
			fontFamily: "'Plus Jakarta Sans', sans-serif",
			foreColor: theme.palette.text.secondary,
			toolbar: {
				show: false,
			},
			animations: {
				enabled: true,
				speed: 800,
				easing: "easeinout",
				animateGradually: {
					enabled: true,
					delay: 150,
				},
				dynamicAnimation: {
					enabled: true,
					speed: 350,
				},
			},
		},
		colors,
		plotOptions: {
			pie: {
				startAngle: -90,
				endAngle: 90,
				offsetY: 10,
				donut: {
					size: "75%",
					background: "transparent",
				},
			},
		},
		grid: {
			padding: {
				bottom: -100,
			},
		},
		tooltip: {
			enabled: true,
		},
		stroke: {
			show: false,
		},
		dataLabels: {
			enabled: false,
		},
		legend: {
			show: false,
			labels: {
				colors: theme.palette.text.secondary,
			},
			markers: {
				size: 5,
				width: 5,
				height: 5,
				radius: 4,
				offsetX: -8,
				strokeWidth: 0,
			},
			itemMargin: {
				horizontal: 15,
				vertical: 5,
			},
			formatter: (seriesName, opts) => {
				const percentage = opts.w.globals.seriesPercent[opts.seriesIndex];
				return `${seriesName} - ${percentage}%`;
			},
			containerMargin: 0,
		},
		labels,
		responsive: [
			{
				breakpoint: 991,
				options: {
					chart: {
						width: "100%",
					},
				},
			},
		],
	};

	return { options, chartSeries };
};
